import { useAppSelector } from "app/redux-store-interactions";
import { type BaseWindowProps } from "contexts/windows";
import { selectObjectTreeV2 } from "slices/explorer";

import { ObjectTreeWindow } from "./objectTreeWindow";
import { ObjectTreeWindowV2 } from "./objectTreeWindowV2";

export function ObjectTreeWindowRouter({ onClose, position }: BaseWindowProps) {
    const isV2 = useAppSelector(selectObjectTreeV2);
    return isV2 ? (
        <ObjectTreeWindowV2 onClose={onClose} position={position} />
    ) : (
        <ObjectTreeWindow onClose={onClose} position={position} />
    );
}
